import React, { useState, useEffect, memo } from "react";

const TestIntroduction = memo( function TestIntroduction({ setNextFlag }) {

	useEffect(() => {
		setNextFlag(true);
	}, []);
	
	return (
		<div className="col-xs-12 successContent mock-resource-text">
			<div className="row w-100">
				<div className="col-lg-12">
					<h4 className="mt-0">Test Introduction</h4>
					<h6>This test measures the Reading, Writing, Listening and Speaking skills in English that you will need in an academic setting.</h6>
					<ol style={{ listStyle: "auto" }}>
						<li>The test is divided into 3 parts. Each part may contain a number of sections. The sections are individually timed. The timer will be shown in the top right corner of your screen. The number of items in the section will also be displayed.
							<div className="timeBlock">
								<div className="timeBlockInr text-right">
									<p><i className="fa fa-clock-o" aria-hidden="true"></i> Time Remaining : 00:32:56</p>
									<p>Item 22 of 39</p>                          
								</div>
							</div>
						</li>
						<li>At the beginning of each part you will receive instructions. These will provide details on what to expect in that part of the test.</li>
						<li>By clicking on the Next (N) button at the bottom of each screen you confirm your answer and move to the next question. If you click on Next (N) you will not be able to return to the previous question. You will not be able to revisit any question at the end of the test.</li>
						<li>You will be offered a break of up to 10 minutes before Listening part. The break is optional.</li>
						<li>This test makes use of different varieties of English, for example, British, American, Australian. You can answer in the standard English variety of your choice.</li>
					</ol>
				</div>
			</div>
		</div>
	);
});

export default TestIntroduction;